import React__default, { useEffect } from 'react';
import { __rest, __assign } from '../../_virtual/_tslib.js';
import { format } from 'date-fns';
import classnames from 'classnames';
import styles from './styles.css.js';

var MessageBubble = function MessageBubble(_a) {
  var message = _a.message,
      onLoaded = _a.onLoaded,
      rest = __rest(_a, ["message", "onLoaded"]);
  /**
   * This ensures that the scroll container is reset to the correct position when rich cards are loaded
   * Previously, the scroll container was only reset for <MessageText/> components
   */


  useEffect(function () {
    onLoaded && onLoaded();
  });
  return React__default.createElement(MessageBubbleRawText, __assign({
    title: "" + format(message.sentAt.toDate(), "iii, MMM do 'at' h:mm a")
  }, rest));
};
/**
 *
 * This is useful to display a message without a MessgeModal
 */


var MessageBubbleRawText = function MessageBubbleRawText(_a) {
  var _b;

  var className = _a.className,
      title = _a.title,
      fullWidth = _a.fullWidth,
      rest = __rest(_a, ["className", "title", "fullWidth"]);

  var classes = classnames(className, styles.messageBubble, styles.flat, (_b = {}, _b[styles.fullWidth] = fullWidth, _b));
  return React__default.createElement("div", __assign({
    title: title,
    className: classes
  }, rest));
};

export default MessageBubble;
export { MessageBubbleRawText };
//# sourceMappingURL=index.js.map
